import React, { ReactNode } from 'react'

import { cn } from '@/utils'

interface PropsIn {
  title?: string
  extra?: ReactNode
  children?: ReactNode
  rootClassName?: string
  id?: string
}

/**
 * Story公用卡片模块
 * @param title 左侧卡片标题
 * @param extra 右侧选项
 * @param children 子组件
 * @param rootClassName 根类名
 * @returns
 */
const CardLayout = React.forwardRef<HTMLDivElement, PropsIn>((props: PropsIn, ref) => {
  const { title, extra, children, rootClassName, id } = props
  return (
    <div className={cn('flex flex-col', rootClassName)} ref={ref} id={id}>
      <div className={cn('mb-[30px] flex items-center justify-between px-[30px] md:px-0')}>
        <span className={cn('h-[37px] font-geologica text-[30px] font-normal leading-[35px] text-base-text-color')}>{title}</span>
        {extra ? extra : null}
      </div>
      {children ? children : null}
    </div>
  )
})
CardLayout.displayName = 'CardLayout'

export default CardLayout
